import { render, staticRenderFns } from "./subscription-view-only.vue?vue&type=template&id=09ceddba&scoped=true&"
import script from "./subscription-view-only.vue?vue&type=script&lang=js&"
export * from "./subscription-view-only.vue?vue&type=script&lang=js&"
import style0 from "./subscription-view-only.vue?vue&type=style&index=0&id=09ceddba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ceddba",
  null
  
)

/* custom blocks */
import block0 from "./subscription-view-only.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports